export default __webpack_public_path__ + "static/Sensor-data-exchange-7a3f412984649fff7567e630ebdf3888.webp";